import f from "./extends3.mjs";
import { DATE_VALIDATION_PROP_NAMES as s, TIME_VALIDATION_PROP_NAMES as a, DATE_TIME_VALIDATION_PROP_NAMES as E } from "./extractValidationProps.mjs";
const d = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "readOnly", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef"], _ = (c, o) => {
  const t = f({}, c), n = {}, e = (r) => {
    t.hasOwnProperty(r) && (n[r] = t[r], delete t[r]);
  };
  return d.forEach(e), o === "date" ? s.forEach(e) : o === "time" ? a.forEach(e) : o === "date-time" && (s.forEach(e), a.forEach(e), E.forEach(e)), {
    forwardedProps: t,
    internalProps: n
  };
};
export {
  _ as splitFieldInternalAndForwardedProps
};
//# sourceMappingURL=fields.mjs.map
